import React from 'react'
import { LoadingOverlayProps, StyledLoadingOverlay } from './styled'

const Index: React.FC<LoadingOverlayProps> = (props) => {
  return (
    <StyledLoadingOverlay {...props} />
  )
}

export default Index
